import React from 'react';
import { Star } from 'lucide-react';
interface StarRatingProps {
  rating: number;
  maxRating?: number;
  size?: 'sm' | 'md' | 'lg';
  showNumber?: boolean;
  interactive?: boolean;
  onChange?: (rating: number) => void;
}
export function StarRating({
  rating,
  maxRating = 5,
  size = 'md',
  showNumber = true,
  interactive = false,
  onChange
}: StarRatingProps) {
  const sizeClasses = {
    sm: 'w-3 h-3',
    md: 'w-4 h-4',
    lg: 'w-5 h-5'
  };
  const handleClick = (value: number) => {
    if (interactive && onChange) {
      onChange(value);
    }
  };
  return <div className="flex items-center gap-1" data-id="element-1130">
      {Array.from({
      length: maxRating
    }, (_, i) => {
      const starValue = i + 1;
      const isFilled = starValue <= Math.floor(rating);
      const isPartial = starValue === Math.ceil(rating) && rating % 1 !== 0;
      return <button key={i} type="button" onClick={() => handleClick(starValue)} disabled={!interactive} className={`${interactive ? 'cursor-pointer hover:scale-110' : 'cursor-default'} transition-transform`} data-id="element-1131">
              <Star className={`${sizeClasses[size]} ${isFilled ? 'fill-yellow-500 text-yellow-500' : isPartial ? 'fill-yellow-300 text-yellow-500' : 'fill-none text-gray-300'}`} data-id="element-1132" />
            </button>;
    })}
      {showNumber && <span className="text-sm font-bold text-gray-700 ml-1" data-id="element-1133">
          {rating.toFixed(1)}
        </span>}
    </div>;
}